export default "__VITE_ASSET__DRrOim0c__"